import request from '@/utils/request'

let Poject_menuApi = {

  /*项目投资类目列表*/
  list(data) {
    return request._post('/shop/plus.poject_menu.Index/index', data);
},
/*添加项目投资类目*/
add(data) {
    return request._post('/shop/plus.poject_menu.Index/add', data);
},
/*修改项目投资类目*/
edit(data) {
    return request._post('/shop/plus.poject_menu.Index/edit', data);
},
/*删除项目投资类目*/
del(data) {
    return request._post('/shop/plus.poject_menu.Index/del', data);
},
/*项目投资类目详情*/
detail(data) {
  return request._post('/shop/plus.poject_menu.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.poject_menu.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.poject_menu.Setting/getSetting', data, errorback);
    },
}
export default Poject_menuApi;



// WEBPACK FOOTER //
// ./src/api/poject_menu.js